import React, { useState, useEffect } from 'react';
// import '../css/AutoComplete.css'
import '../App.css'

export default function Input({ value='', parameters }) {

    const [valueInput, setValueInput] = useState(value ?? '');

    useEffect(() => {
        setValueInput(value ?? '');
    }, [value]);

    return (
        <div className="input-group" style={{ "width": parameters.width || '30%' }} >
            <input id={parameters.id}
                type={parameters.type || "text"}
                min={parameters.min ?? undefined}
                max={parameters.max ?? undefined}
                step={parameters.step ?? undefined}
                value={valueInput || ''}
                style={parameters.error ? 
                    {...parameters?.style, "borderBottom": "2px solid red" } : 
                    {...parameters?.style} 
                }
                onChange={(e) => {
                    const novoValor = e.target.value;

                    if (parameters.type === 'number' && novoValor !== '') {
                        const valorNumerico = Number(novoValor);

                        if (!Number.isFinite(valorNumerico)
                            || (parameters.min !== undefined && valorNumerico < parameters.min)
                            || (parameters.max !== undefined && valorNumerico > parameters.max)) {
                            return;
                        }
                    }

                    setValueInput(novoValor)
                    parameters.onChange(novoValor)
                }}
                disabled={parameters.disabled}
                required={parameters.required} />

            <label htmlFor={parameters.id} style={parameters.error ? { "color": "red" } : {}}>{parameters.label}</label>
        </div>
    );
}

